import Swiper from 'swiper';
import 'jquery.easing';

export function buyFunc() {

  const buyPage = $('#buy').length;
  const buySlider = $('.buySlider');

  const subNav = document.getElementById('subNav');
  const subNavBtn = document.getElementById('subNavBtn');
  const subNavMenu = document.getElementById('subNavMenu');

  const toggleParent = $('.toggleParent');
  const toggleBtn = $('.toggleBtn');
  const toggleContent = $('.toggleContent');

  const researchBtn = $('#researchBtn');

  const storeFilter = $('#storeFilter');
  const storeSearch = $('#storeSearch');

  const header = $('#header');

  if (buyPage) {

    header.addClass('shadow');

    $(window).on('scroll', function () {
      let scrTop = $(window).scrollTop();
      if (scrTop > 20) {
        subNav.classList.add('notTop');
      } else {
        subNav.classList.remove('notTop');
      }
    });

    subNavBtn.addEventListener('click', function () {
      if (subNavMenu.classList.contains('isOpen')) {
        subNavBtn.classList.remove('isOpen');
        subNavMenu.classList.remove('isOpen');
      } else {
        subNavBtn.classList.add('isOpen');
        subNavMenu.classList.add('isOpen');
      }
    });

    if (toggleParent.length) {
      toggleBtn.on('click', function () {
        if ($(this).hasClass('isClose')) {
          $(this).removeClass('isClose');
          $(this).closest(toggleParent).find(toggleContent).slideUp(500);
          if (toggleParent.hasClass('online')) {
            $(this).text('OPEN');
          } else {
            $(this).text('MORE');
          }
        } else {
          $(this).addClass('isClose');
          $(this).closest(toggleParent).find(toggleContent).slideDown(500);
          $(this).text('CLOSE');
          if (toggleParent.hasClass('online')) {
            $(this).closest(toggleParent).find(toggleContent).css('display', 'flex');
          }
        }
      });
    }

    if ($('#researchTrigger').length) {
      researchBtn.on('click', function () {
        $('body,html').animate({
          scrollTop: 0
        }, 500, 'swing');
        return false;
      });

      const clientHeight = document.documentElement.clientHeight;

      const options = {
        rootMargin: "-10% 0px -80%"
      };

      const callback = (function (changes) {
        for (let change of changes) {
          if (change.isIntersecting) {
            researchBtn.addClass('isShow');
          } else {
            researchBtn.removeClass('isShow');
          }
        }
      });

      const observer = new IntersectionObserver(callback, options);

      const target = document.querySelector('#researchTrigger')
      observer.observe(target)
    }

    if (buySlider.length) {
      let buySwiper, buyOptions;
      buySwiper = undefined;
      buyOptions = {
        loop: true,
        speed: 800,
        effect: 'slide',
        normalizeSlideIndex: true,
        paginationClickable: true,
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        preloadImages: false,
        lazy: {
          elementClass: 'lazyload',
          loadPrevNextAmount: 2,
          loadPrevNext: true
        },
      };
      buySwiper = new Swiper('.buySlider', buyOptions);
    }

    if (storeFilter.length) {
      filterFunc();
      $("input[type='checkbox']").click(function () {
        filterFunc();
      });
    }

    if (storeSearch.length) {
      searchFunc();
    }

    buyHeight();

    let url = document.location.href;
    if (url.match('store-result')) {
      const result = $('#researchTrigger');
      const breakPoint = 750;
      if (breakPoint < window.innerWidth) {
        let pos = storeFilter.offset().top;
        $('body,html').animate({
          //scrollTop: pos * 1.5
          scrollTop: pos * 1.7 //IN-STORE検索仕様改修による修正
        }, 1000, 'easeInOutQuart');
        return false;
      } else {
        let pos = result.offset().top;
        $('body,html').animate({
          scrollTop: pos * 0.8
        }, 1000, 'easeInOutQuart');
        return false;
      }
    }
  }
}

function filterFunc() {
  const filterBtn = $('#filterBtn');
  const searchAllBtn = $('#searchAllBtn'); //IN-STORE検索仕様改修による追加
  let storeFlag = false;
  let storeCount = 0;
  const storeType = document.querySelectorAll('input[name="store[]"]');
  for (let i = 0; i < storeType.length; i++) {
    if (storeType[i].checked) {
      storeCount++;
    }
  }
  if (storeCount > 0) {
    storeFlag = true;
  } else {
    storeFlag = false;
  }
  let areaFlag = false;
  let areaCount = 0;
  const areaType = document.querySelectorAll('input[name="area[]"]');

  let allFlag = false; //全店舗検索ボタンアクティブ判定フラグ
  const searchAll = document.querySelectorAll('input[name="all"]'); //全店舗検索ボタン

  for (let i = 0; i < areaType.length; i++) {
    if (areaType[i].checked) {
      areaCount++;
    }
  }
  if (areaCount > 0) {
    areaFlag = true;
    searchAll[0].checked = false; //地域ボタン選択されたら全店舗ボタン非アクティブ
  } else {
    areaFlag = false;
  }

  if (searchAll[0].checked) {
    allFlag = true; //全店舗検索ボタンがクリックされていたらアクティブフラグon
  } else {
    allFlag = false; //全店舗検索ボタンがクリックされてなければアクティブフラグoff
  }

  //if (storeFlag && areaFlag) {
  if ((storeFlag && areaFlag) || (storeFlag && allFlag)) { //IN-STORE検索仕様改修による修正
    filterBtn.prop('disabled', false); //店舗ボタンと地域ボタンor全店舗検索ボタンがクリックされていれば検索ボタンアクティブ
  } else {
    filterBtn.prop('disabled', true);
  }

  $("#resetBtn").click(function () {
    filterBtn.prop('disabled', true);
    for (let i = 0; i < storeType.length; i++) {
      storeType[i].checked = false;
    }
    for (let i = 0; i < areaType.length; i++) {
      areaType[i].checked = false;
    }
    searchAll[0].checked = false; //IN-STORE検索仕様改修による追加
  });


  searchAllBtn.click(function () { //全店舗検索ボタンがクリックされたら地域ボタン非アクティブ化
    for (let i = 0; i < areaType.length; i++) {
      areaType[i].checked = false;
    }
  });

}

function searchFunc() {
  const searchBtn = $('#searchBtn');
  let flag = false;
  $('#area').change(function () {
    let areaSelected = storeSearch.area.selectedIndex;
    if (areaSelected > 0) {
      flag = true;
    } else {
      flag = false;
    }
    if (flag) {
      searchBtn.prop('disabled', false);
    } else {
      searchBtn.prop('disabled', true);
    }
  });
}

function equalBoxHeight(elm, num) {
  var elm = $(elm);
  elm.each(function (i) {
      var height;
      var $this = $(this);

      if (i === 0 || i % num === 0) {
          height = $this.height();

          for (var n = i + 1; n <= i + num - 1; n++) {
              if (height < elm.eq(n).height()) {
                  height = elm.eq(n).height();
              }
          }

          for (var n = i; n <= i + num - 1; n++) {
              elm.eq(n).css("height", height + "px");
          }
      }
  });
}
function buyHeight() {
    const breakPoint01 = 1366;
    const breakPoint02 = 768;
    let windowWidth = window.innerWidth;

    console.log(windowWidth);

    if (windowWidth > breakPoint01) {
      $(".buyStoreOtherListItemTxt").css("height", "");//リセット
      equalBoxHeight(".buyStoreOtherListItemTxt", 4);
    } else if (windowWidth > breakPoint02) {
      $(".buyStoreOtherListItemTxt").css("height", "");//リセット
      equalBoxHeight(".buyStoreOtherListItemTxt", 2);
    } else {
      $(".buyStoreOtherListItemTxt").css("height", "");
    }
}
$(window).on('resize', function () {
  buyHeight();
});